// about vuex
// The MIT License (MIT)
//
// Copyright (c) 2015-present Evan You
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import dmUtil from "../../pages/dataMonitor/dataMonitorUtil";

const SYSTEM_NAME_SEPARATOR = '/';

export default {
  name: "multipleFunctions",

  computed: {
    /**
     * 選択したシステムのリソースキーの配列
     */
    systemNames() {
      return this.$route.params.systemIds ? this.$route.params.systemIds : [];
    },
  },

  methods: {
    /**
     * システムのリソースキーの配列を翻訳して返す
     * @param {array} resourceKeys システムのリソースキーの配列
     * @returns {string} 翻訳して各リソース名を'/'で繋いだ文字列
     */
    translateSystemNames(resourceKeys) {
      return resourceKeys.map(key => {
        const sysName = this.$t('diagSytem.' + key);
        return sysName + '(' + dmUtil.getAbbrSysName(key) + ')';
      }).join(SYSTEM_NAME_SEPARATOR);
    }
  },

  /**
   * DOM 生成後に呼ばれるイベント
   */
  mounted() {
    this.$emit("setVehicleTabsAvailable", true);
  },
};
